// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".joblistwidget .powered-by[data-v-81d703aa]{color:#818795;font-size:.75rem}.joblistwidget .no-positions[data-v-81d703aa]{display:flex;justify-content:center;color:#818795}.joblistwidget .no-positions h3[data-v-81d703aa]{font-weight:500}", ""]);
// Exports
module.exports = exports;
